import { render, staticRenderFns } from "./MainFrameCenter.vue?vue&type=template&id=58fc77c2"
import script from "./MainFrameCenter.vue?vue&type=script&lang=js"
export * from "./MainFrameCenter.vue?vue&type=script&lang=js"
import style0 from "./MainFrameCenter.vue?vue&type=style&index=0&id=58fc77c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports